import { get } from "./utils.service";

export const getUserConversations = async (user, page, limit) => {
  return await get(`/admin/user-conversations?page=${page}&limit=${limit}&user=${user}`);
};

export const getConversationMessages = async (conversationId, userId, page) => {
  return await get(
    `/admin/conversation-messages/${conversationId}?userId=${userId}&page=${page}`
  );
};
